import { render } from "./Tos.vue?vue&type=template&id=5cb4d988"
import script from "./Tos.vue?vue&type=script&lang=js"
export * from "./Tos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__